__webpack_require__.p = "https://pos.byonde.asia/";